<template>
	<div class="cover-container">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'CoverContainer',
		mounted() {
			this.slotEl = this.$slots.default[0].elm;
			this.slotEl.style.position = 'absolute';
			this.slotEl.style.left = '50%';
			this.slotEl.style.top = '50%';
			this.slotEl.style.transform = 'translate3d(-50%,-50%,0)';
			window.addEventListener('resize', () => {
				this.doCover();
			});
			this.doCover();

			this.slotEl.addEventListener('loadedmetadata', () => {
				this.doCover();
			});
//      this.slotEl.addEventListener('playing', ()=>{
//          this.doCover();
//      });
		},
		methods: {
			doCover() {
				let el = this.slotEl;
				let st = getComputedStyle(this.$el);
				let cntWidth = parseInt(st.width),
					cntHeight = parseInt(st.height),
					vW = el.videoWidth,
					vH = el.videoHeight;
				console.log(this.$el);
				let rW, rH;
				let videoAspectRatio = (vH / vW),
					cntAspectRatio = cntHeight / cntWidth;
				if (cntAspectRatio < videoAspectRatio) {
					rW = cntWidth;
					rH = cntWidth / vW * vH;
				} else {
					rH = cntHeight;
					rW = cntHeight / vH * vW;
				}

				el.style.width = rW + 'px';
				el.style.height = rH + 'px';
			}
		}
	}
</script>



// WEBPACK FOOTER //
// CoverContainer.vue?7829b877